$(function() {
	
	$("#calendar-link").on("click", function() {
		
		$("#calendar-modal").load("/calendar", function() {
		   	
			var options = {
				todayBtn: true,
				format: "mm/dd/yyyy",
		   		weekStart: 1,
		   		todayHighlight: true,
		   		calendarWeeks: true,
		   		language: ebusy.locale.replace("_", "-"),
		   		templates: {
		   		    leftArrow: '<i class="icon-chevron-left"></i>',
		   		    rightArrow: '<i class="icon-chevron-right"></i>'
		   		}
	   		};
			
			if(!ebusy.userLevel || (ebusy.userLevel !== 'OPERATOR' && ebusy.userLevel !== 'ADMINISTRATOR' && ebusy.userLevel !== 'GOD')) {
				options.startDate = "+0d";
			}
			
			$(".modal-content", $(this)).datepicker(options).on("changeDate", function(e) {
				var pricesForParam = ebusy.getGetParameter("prices-for");
				var pricesForPart = pricesForParam ? "&prices-for=" + pricesForParam : "";
				location.href = $("#calendar-link").data("url") + "?selectedDate=" + e.format(0, "mm/dd/yyyy") + pricesForPart;
		    });

			$(".today", $(".modal-content")).on("click", function(e) {
				
				var today = new Date();
				var dd = String(today.getDate()).padStart(2, '0');
				var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
				var yyyy = today.getFullYear();
				
				location.href = $("#calendar-link").data("url") + "?selectedDate=" + mm + "/" + dd + "/" + yyyy;
		    });
			
			$("#calendar-modal").modal();
		});
	});
	
});
